import Vue from "vue";
import Router from "vue-router";
import { Role } from "@/_helpers/roles";
import { funcs } from "@/_helpers/_sumple_funcs";

import store from "@/store/index";
import guest from "./middleware/guest";
import auth from "./middleware/auth";
import middlewarePipeline from "./middlewarePipeline";
// Containers
import DefaultContainer from "@/containers/DefaultContainer.vue";

// Views
import Login from "@/views/Login";

import Category from "@/views/category/Index";
import CategoryStore from "@/views/category/Store";
import CategoryUpdate from "@/views/category/Update";

import AllProducts from "@/views/product/AllProducts";
import Product from "@/views/product/Index";
import ProductStore from "@/views/product/Store";
import ProductUpdate from "@/views/product/Update";

import Field from "@/views/field/Index";
import FieldStore from "@/views/field/Store";
import FieldUpdate from "@/views/field/Index";

import Unit from "@/views/unit/Index";
import UnitStore from "@/views/unit/Store";
import UnitUpdate from "@/views/unit/Update";

import Language from "@/views/language/Index";
import LanguageStore from "@/views/language/Store";

import User from "@/views/user/Index";

import Tree from "@/views/allLogic/Tree";
import Report from "@/views/report/Index";
import Logs from "@/views/logs/Index";
import Verification from "@/views/validateAction/Index";
import UserVerifications from "@/views/validateAction/userValidations";
import Suggestions from "@/views/suggestions/Index";
import Translations from "@/views/translations/Index";

import CombinationV2 from "@/views/combinationv2/Index.vue";
import CombinationDetail from "@/views/combinationv2/Detail.vue";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/tree",
      name: "Home",
      component: DefaultContainer,
      meta: {
        middleware: [auth],
      },
      children: [
        /*********************** TREE ***********************/
        {
          path: "/tree",
          name: "tree",
          component: Tree,
          meta: { middleware: [auth] },
        },
        /*********************** REPORT ***********************/
        {
          path: "/reports",
          name: "reports",
          component: Report,
          meta: { middleware: [auth] },
        },
        /*********************** CATEGORY ***********************/
        {
          path: "/category",
          name: "category",
          component: Category,
          meta: { middleware: [auth] },
        },
        {
          path: "/categoryStore",
          name: "categoryStore",
          component: CategoryStore,
          meta: { middleware: [auth] },
        },
        {
          path: "/categoryUpdate/:category_id",
          name: "categoryUpdate",
          component: CategoryUpdate,
          meta: { middleware: [auth] },
        },
        /*********************** PRODUCTS ***********************/
        {
          path: "/products",
          name: "products",
          component: AllProducts,
          meta: { middleware: [auth] },
        },
        {
          path: "/productsByCategory/:category_id",
          name: "productsByCategory",
          component: Product,
          meta: { middleware: [auth] },
        },
        {
          path: "/productsByCategory/:category_id/productStore",
          name: "productStore",
          component: ProductStore,
          meta: { middleware: [auth] },
        },
        {
          path: "/productUpdate/categoryId/:category_id/productId/:product_id",
          name: "productUpdate",
          component: ProductUpdate,
          meta: { middleware: [auth] },
        },
        /*********************** FIELDS ***********************/
        {
          path: "/fieldByProduct/:product_id",
          name: "fieldsByProduct",
          component: Field,
          meta: { middleware: [auth] },
        },
        {
          path: "/fieldByProduct/:product_id/store",
          name: "fieldStore",
          component: FieldStore,
          meta: { middleware: [auth] },
        },
        {
          path: "/fieldUpdate/:field_id",
          name: "fieldUpdate",
          component: FieldUpdate,
          meta: { middleware: [auth] },
        },
        /*********************** UNITS ***********************/
        {
          path: "/unit",
          name: "unit",
          component: Unit,
          meta: { middleware: [auth], role: [Role.admin] },
        },
        {
          path: "/unit",
          name: "unitStore",
          component: UnitStore,
          meta: { middleware: [auth], role: [Role.admin] },
        },
        {
          path: "/unitUpdate/:unit_id",
          name: "unitUpdate",
          component: UnitUpdate,
          meta: { middleware: [auth], role: [Role.admin] },
        },

        /*********************** LANGUAGE ***********************/
        {
          path: "/language",
          name: "language",
          component: Language,
          meta: { middleware: [auth], role: [Role.admin] },
        },
        {
          path: "/language/store",
          name: "languageStore",
          component: LanguageStore,
          meta: { middleware: [auth], role: [Role.admin] },
        },
        /*********************** USER ***********************/
        {
          path: "/user",
          name: "user",
          component: User,
          meta: { middleware: [auth], role: [Role.admin] },
        },
        /*********************** Action verification ***********************/
        {
          path: "/verification",
          name: "verification",
          component: Verification,
          meta: { middleware: [auth], role: [Role.admin] },
        },
        {
          path: "/myverifications",
          name: "userVerification",
          component: UserVerifications,
          meta: { middleware: [auth] },
        },
        /*********************** SUGGESTIONS ***********************/
        {
          path: "/suggestions",
          name: "suggestions",
          component: Suggestions,
          meta: { middleware: [auth] },
        },
        /*********************** TRANSLATIONS ***********************/
        {
          path: "/translations",
          name: "translations",
          component: Translations,
          meta: { middleware: [auth] },
        },
        /*********************** LOGS ***********************/
        {
          path: "/logs",
          name: "logs",
          component: Logs,
          meta: { middleware: [auth] },
        },
        /*********************** COMBINATION-v2 ***********************/
        {
          path: "/combination-v2",
          name: "combination-v2",
          component: CombinationV2,
          meta: { middleware: [auth], role: [Role.combination_user] },
        },
        {
          path: "/combination-detail/:id",
          name: "combination-detail",
          component: CombinationDetail,
          meta: { middleware: [auth], role: [Role.combination_user] },
        },
      ],
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        middleware: [guest],
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const { middleware, role } = to.meta;

  if (role) {
    let found = false;
    let user = JSON.parse(localStorage.getItem("user"));
    if (user && user.roles) {
      let BreakException = {};
      try {
        role.forEach((roleName) => {
          if (funcs.inArray(roleName, user.roles)) {
            throw BreakException;
          }
        });
      } catch (e) {
        if (e === BreakException) found = true;
      }
    } else {
      return next({
        name: "Login",
      });
    }
    if (!found) {
      return next({
        name: from.name,
      });
    }
  }

  if (middleware) {
    const context = {
      to,
      from,
      next,
      store,
    };

    return middleware[0]({
      ...context,
      next: middlewarePipeline(context, middleware, 1),
    });
  }

  return next();
});

export default router;
